/**
 * Sport Logo Mapping
 *
 * Maps sport codes to their logo asset paths.
 * Used by admin list pages, frontend sport filters, etc.
 */

/** Map from uppercase sport code to logo path */
export const SPORT_LOGO_MAP: Record<string, string> = {
  NFL: '/league-icon.svg',
  NBA: '/nba-logo.svg',
  NHL: '/nhl-logo.png',
  NCAAMB: '/nba-logo.svg',
  NCAAF: '/league-icon.svg',
  MLB: '/mlb-logo.svg',
  PGA: '/pga-logo.svg',
  SOCCER: '/soccer-logo.svg',
  MIXED: '/dk-logo.svg',
};

const DEFAULT_LOGO = '/league-icon.svg';

/**
 * Get the logo URL for a sport.
 * @param sport - Uppercase sport code (e.g. 'NFL', 'NBA'). Case-insensitive.
 * @returns Logo path string
 */
export function getSportLogoUrl(sport?: string): string {
  if (!sport) return DEFAULT_LOGO;
  return SPORT_LOGO_MAP[sport.toUpperCase()] || DEFAULT_LOGO;
}
